// Shared Framer Motion animation constants to prevent unnecessary re-renders
export const FADE_IN_UP_HIDDEN = { y: 20, opacity: 0 };
export const FADE_IN_UP_SHOWN = { y: 0, opacity: 1 };

export const FADE_IN_HIDDEN = { opacity: 0 };
export const FADE_IN_SHOWN = { opacity: 1 };

export const STAGGER_CONTAINER = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: { staggerChildren: 0.1 },
  },
};

export const STAGGER_ITEM = {
  hidden: { y: 20, opacity: 0 },
  show: { y: 0, opacity: 1 },
};

export const STAGGER_TRANSITION = { staggerChildren: 0.1 };

export const DELAYED_FADE_IN_UP = (delay) => ({
  initial: FADE_IN_UP_HIDDEN,
  animate: FADE_IN_UP_SHOWN,
  transition: { delay },
});

// Recharts shared style constants
export const RECHARTS_TOOLTIP_STYLE = {
  backgroundColor: '#FFFFFF',
  border: '1px solid #E2E8F0',
  borderRadius: '8px',
  padding: '8px',
};

export const RECHARTS_DOT = { fill: '#0052FF', r: 4 };
export const RECHARTS_ACTIVE_DOT = { r: 6 };
